module.exports = __webpack_public_path__ + "media/img/Landing_Page/s2u-contact-banner-8d6d4392ddc2d590cc30fc72d81dd58a.jpg";